module.exports = __webpack_public_path__ + "static/media/md-arrow-back.f281d4c6.svg";